const backdropActionTypes = {
  TOGGLE_BACKDROP_STATE: "TOGGLE_BACKDROP_STATE",
  TOGGLE_BACKDROP_TWO_STATE: "TOGGLE_BACKDROP_TWO_STATE",
};

export default backdropActionTypes;
